import PropTypes from 'prop-types';
import React from 'react';
import ListItemCreated from 'shared/_components/list/list-item-created';

const AudioListItemDetails = ({ item }) => (
    <>
        <ListItemCreated key="created" value={item.created} />
        <div key="additionalInfo">
            Full Length | YT
        </div>
    </>
);
AudioListItemDetails.propTypes = {
    item: PropTypes.shape({
        created: PropTypes.string,
    }),
};

export default AudioListItemDetails;
